const users = [
  {
    photo: "./../../img/image-tanya.jpg",
    name: "Tanya Sinclair",
    title: "UX Engineer",
    testimonial:
      "I’ve been interested in coding for a while but never taken the jump, until now. I couldn’t recommend this course enough. I’m now in the job of my dreams and so excited about the future.",
  },

  {
    photo: "./../../img/image-john.jpg",
    name: "John Tarkpor",
    title: "Junior Front-end Developer",
    testimonial:
      "If you want to lay the best foundation possible I’d recommend taking this course. The depth the instructors go into is incredible. I now feel so confident about starting up as a professional developer.",
  },
];

export default users;
